module.exports = __webpack_public_path__ + "da704ccb036f6b0fb08ddd2c51be4ea6.webp";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/key-art-1024.webp
// module id = 421
// module chunks = 0